import { render } from "./MediaflowDashboard.vue?vue&type=template&id=657b58b2"
import script from "./MediaflowDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/MediaflowDash/MediaflowDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "657b58b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('657b58b2', __exports__)) {
    api.reload('657b58b2', __exports__)
  }
  
  module.hot.accept("./MediaflowDashboard.vue?vue&type=template&id=657b58b2", () => {
    api.rerender('657b58b2', render)
  })

}


export default __exports__